import { AppProvider } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AppFrame } from './components/AppFrame';
import { OnboardingGate } from './components/OnboardingGate';
import { AnalyticsPage } from './pages/AnalyticsPage';
import { BillingPage } from './pages/BillingPage';
import { CampaignsPage } from './pages/CampaignsPage';
import { CampaignBuilderPage } from './pages/CampaignBuilderPage';
import { ComingSoonPage } from './pages/ComingSoonPage';
import { CouponsPage } from './pages/CouponsPage';
import { CustomersPage } from './pages/CustomersPage';
import { DeveloperSettingsPage } from './pages/DeveloperSettingsPage';
import { DashboardPage } from './pages/DashboardPage';
import { GamesPage } from './pages/GamesPage';
import { HelpPage } from './pages/HelpPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { RewardsPage } from './pages/RewardsPage';
import { SettingsPage } from './pages/SettingsPage';
import { SupportPage } from './pages/SupportPage';
import { ThemesPage } from './pages/ThemesPage';
import { WelcomeWizard } from './pages/WelcomeWizard';

/** Sections not yet built get a placeholder route. */
const PLACEHOLDER_ROUTES: Array<{ path: string; title: string }> = [
  { path: '/assets', title: 'Assets' },
];

export function App(): JSX.Element {
  return (
    <AppProvider i18n={enTranslations}>
      <BrowserRouter>
        <AppFrame>
          <OnboardingGate>
            <Routes>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/welcome" element={<WelcomeWizard />} />
              <Route path="/campaigns" element={<CampaignsPage />} />
              <Route path="/campaigns/:id" element={<CampaignBuilderPage />} />
              <Route path="/billing" element={<BillingPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/developers" element={<DeveloperSettingsPage />} />
              <Route path="/games" element={<GamesPage />} />
              <Route path="/rewards" element={<RewardsPage />} />
              <Route path="/coupons" element={<CouponsPage />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route path="/customers" element={<CustomersPage />} />
              <Route path="/support" element={<SupportPage />} />
              <Route path="/help" element={<HelpPage />} />
              <Route path="/themes" element={<ThemesPage />} />
              {PLACEHOLDER_ROUTES.map((r) => (
                <Route key={r.path} path={r.path} element={<ComingSoonPage title={r.title} />} />
              ))}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </OnboardingGate>
        </AppFrame>
      </BrowserRouter>
    </AppProvider>
  );
}
